export const fetchTypes = (typeGroups, inactive = false) => {
  if (typeGroups) {
    let queryParams = typeGroups.join(",");
    queryParams += "&inactive=" + inactive;
    return fetch(
      process.env.REACT_APP_API_URL + `/api/sql/types?groups=${queryParams}`
    )
      .then(
        response => response.json(),
        error => console.log("An error occurred.", error)
      )
      .then(json => {
        return json;
      });
  } else {
    return null;
  }
};
